import { AutoUser } from './auto-user';
import { BinaryTree } from './binary-tree';
import { Comment } from './comment';
import { CoordinatorService } from './coordinator.service';

export class AutoUser$ {
    private _autoUserMap = new Map<string, AutoUser>();

    constructor(private coords: CoordinatorService) {
        this.clear();
    }

    get isOn() {
        return !!this._autoUserMap.size;
    }

    get autouserLs() {
        return Array.from(this._autoUserMap.values());
    }

    get hasCurrentSnapshot() {
        for (const au of this._autoUserMap.values()) if (au.isCurrentSnapshot) return true;
        return false;
    }

    has(au: AutoUser) {
        return this._autoUserMap.has(au.id);
    }

    ofOriginCommentLs(originId: string): Comment[] {
        const ls: Comment[] = [];
        this._autoUserMap.forEach((au) => {
            ls.push(...au.ofOriginCommentLs(originId));
        });
        return ls;
    }

    clear() {
        this._autoUserMap.clear();
    }

    activeLs() {
        return Array.from(this._autoUserMap.values()).filter((u) => u.isActive);
    }

    hasAuto(bt: BinaryTree | undefined) {
        return !!this._autoUserMap.size;
        // for (const au of this._autoUserMap.values()) {
        //     if (au.hasAuto(bt)) return true;
        // }
        // return false;
    }

    currentBtLs(bt: BinaryTree) {
        const ls: { au: AutoUser; ndIdLs: string[] }[] = [];
        for (const au of this._autoUserMap.values()) {
            const resp = au.currentBt(bt) || { au, ndIdLs: [] };
            resp && ls.push(resp);
        }
        return ls;
    }

    get(nm: string, isCreate = false) {
        let au = this._autoUserMap.get(nm);

        if (au) return au;

        const normNm = this.coords.utils$.normalizeString(nm);
        for (let au of this._autoUserMap.values()) {
            if (this.coords.utils$.normalizeString(au.name) === normNm) return au;
        }

        if (!isCreate) return null;

        return this.create(nm);
    }

    createFromCurrentUser() {
        console.log('QQQ', this.coords.user$.current);
    }

    create(name: string) {
        if (!name || !name.trim()) return null;
        const au = new AutoUser(this.coords, { name: name });
        this.add(au);
        return au;
    }

    add(au: AutoUser) {
        this._autoUserMap.set(au.id, au);
        au.markForManifestStore();
    }

    delete(au: AutoUser) {
        this._autoUserMap.delete(au.id);
    }

    load3(ls: any[]) {
        ls.forEach((x: any) => {
            const params = x.autoUser;
            if (!params || !params.id) return;
            const au = new AutoUser(this.coords, params);

            au.load3(x);
            this._autoUserMap.set(au.id, au);
        });
    }

    markForManifestStore() {
        this._autoUserMap.forEach((au) => au.markForManifestStore());
    }
}
